/** Marka görselleri (spec Ek A: uploads/ → public/brand/). Prototipte window.BRAND_MARK / window.BRAND_WORD (app-v6.jsx:23-24). */
/** 192 px kayıpsız WebP: en büyük gösterim 88 px (tur karşılama kartı) → 2× (scripts/brand-icons.py). */
export const BRAND_MARK = '/brand/mark-192.webp';
export const BRAND_WORD = '/brand/dent-os.png';
